export default __webpack_public_path__ + "static/media/rightDandiya1024.748f5494.png";